const binding = { modules: {}, dataActions: {} };

    (binding.modules['rda-custom'] = {
        c: () => require('partner/themes/rda-custom/rda-custom.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout','content-block','custom-buybox','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'rda-custom',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'rda-custom.theme.settings.json',
        md: 'src/themes/rda-custom'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };